export { default as AddFundsModalButtonInvoiceNotesAndTermsInfo } from './AddFundsModalButtonInvoiceNotesAndTermsInfo';
